export const domain = 'AddUsersToProjectModalModel'

export const onOpenAddUsersToProjectModal = `${domain}/onOpenAddUsersToProjectModal`
export const onCloseAddUsersToProjectModal = `${domain}/onCloseAddUsersToProjectModal`
